import { useEffect, useState } from 'react';
import { listAuthorizations } from '../api/authorizations';

/** Badge ámbar con la cantidad de autorizaciones pendientes de revisión. */
export default function AutorizacionesBadge() {
  const [count, setCount] = useState(0);

  useEffect(() => {
    let active = true;
    listAuthorizations({ status: 'pendiente' })
      .then((rows) => {
        if (active) setCount(rows.length);
      })
      .catch(() => {});
    return () => {
      active = false;
    };
  }, []);

  if (count === 0) return null;
  return (
    <span className="ml-2 inline-flex items-center justify-center rounded-full bg-amber-500 px-2 py-0.5 text-xs font-semibold text-white">
      {count}
    </span>
  );
}
